import { render, staticRenderFns } from "./MediaField.vue?vue&type=template&id=3d7123d8"
import script from "./MediaField.vue?vue&type=script&lang=js"
export * from "./MediaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports